import { FunctionComponent } from 'react'

import styled, { css, useTheme } from 'styled-components'

import SvgIcon from '@components/SvgIcon'

interface StepProps {
  isActive: boolean
  isCompleted: boolean
  orderNumber: number
  text: string
}

const Wrapper = styled.div`
  ${({
    theme: {
      spacing: { spacing4 },
    },
  }) => css`
    display: flex;
    flex-direction: row;
    gap: ${spacing4};
    justify-content: center;
    align-items: center;
  `}
`

const StyledStep = styled.div<Pick<StepProps, 'isActive' | 'isCompleted'>>`
  ${({
    theme: {
      colors: { textDefault, textDefaultDisabled },
      typography: {
        catchword: {
          small2: { bundledCSS: small2CatchwordCSS },
        },
      },
    },
    isCompleted,
    isActive,
  }) => css`
    color: ${isCompleted || isActive ? textDefault : textDefaultDisabled};
    ${small2CatchwordCSS};
    text-transform: capitalize;
    flex-grow: 1;
  `}
`

const StyledCircle = styled.div<Pick<StepProps, 'isActive'>>`
  ${({
    theme: {
      colors: { iconBrand, iconDefaultDisabled },
      typography: {
        catchword: {
          medium2: { bundledCSS: medium2CatchwordCSS },
        },
      },
      spacing: { spacing2 },
    },
    isActive,
  }) => css`
    color: ${isActive ? iconBrand : iconDefaultDisabled};
    ${medium2CatchwordCSS};
    font-size: 13px;
    width: 20px;
    height: 20px;
    margin: ${spacing2};

    border: 2px solid ${isActive ? iconBrand : iconDefaultDisabled};
    border-radius: 50%;

    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
  `}
`

const Step: FunctionComponent<StepProps> = ({
  isActive,
  orderNumber,
  text,
  isCompleted,
}) => {
  const theme = useTheme()
  return (
    <Wrapper>
      {isCompleted ? (
        <SvgIcon
          iconName="circle-check"
          size={24}
          color={theme.colors.iconBrand}
        />
      ) : (
        <StyledCircle isActive={isActive}>{orderNumber}</StyledCircle>
      )}
      <StyledStep isActive={isActive} isCompleted={isCompleted}>
        {text}
      </StyledStep>
    </Wrapper>
  )
}

export default Step
